import { rootForecast } from "./forecasts";
import { scanSignals } from "./scan";
import type { NetworkNode } from "./types";

const MEMORY_KEYS = ["af_pulse_memory", "cs_pulse_memory"];

type Memory = Record<string, { nodes: NetworkNode[] }>;

function readMemory(): Memory {
  const merged: Memory = {};
  for (const key of MEMORY_KEYS) {
    try {
      Object.assign(merged, JSON.parse(localStorage.getItem(key) || "{}"));
    } catch {
      /* ignore */
    }
  }
  return merged;
}

function writeMemory(topic: string, payload: { nodes: NetworkNode[] }) {
  try {
    const mem = readMemory();
    mem[topic.toLowerCase().trim()] = payload;
    const keys = Object.keys(mem);
    if (keys.length > 50) delete mem[keys[0]];
    localStorage.setItem("af_pulse_memory", JSON.stringify(mem));
  } catch {
    /* ignore */
  }
}

export async function spawnNetwork(
  topic: string,
  _depth: number,
  parentId?: string,
  visited: string[] = [],
): Promise<{ nodes: NetworkNode[]; source: "scan"; rootId: string }> {
  const q = topic.trim();
  const rootId = parentId || rootForecast(q).id;
  const nodes = scanSignals(q, parentId, visited, _depth);
  writeMemory(q, { nodes });
  return { nodes, source: "scan", rootId };
}
